import{isTransparent as e,upgradeColor as t}from"@wix/shoutout-email-model-v3";const n=n=>n&&e(n)?`transparent`:t(n);export{n as getUpgradedColor};
//# sourceMappingURL=get-upgraded-color.js.map